import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import logo from '../../../../../assets/images/national-highways-logo.svg';
import { confirmationSteps } from '../../../../../constants/Constants';
import unionimg from '../../../../../assets/images/Union.svg';
import { litrals } from '../../../../../constants/Litrals';
import ConfirmSubscriptionStep1 from '../../molecules/ConfirmSubscriptionStep1';
import ConfirmSubscriptionStep2 from '../../molecules/ConfirmSubscriptionStep2/ConfirmSubscriptionStep2';
import ConfirmDataModal from '../../molecules/DataFeedModal';
import Alert from '../../../../ntisui/Atoms/Alerts';
import './ConfirmSubscriptionContainer.scss';
import { updateData } from '../../../../../api/ApiCommunication';
import { useMsal } from '@azure/msal-react';
import { AlertType } from '../../../SubscriberDataFeed/organisms/types/IConfigureDataFeed';

function ConfirmSubscriptionContainer() {
  const [activeStep, setActiveStep] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [subscriptionCancel, setSubscriptionCancel] = useState(false);
  const [isAlert, setIsAlert] = useState('');
  const [alertMsg, setAlertMsg] = useState('');
  const { accounts } = useMsal();
  const userId = (accounts && accounts[0] && accounts[0].localAccountId) || '';

  const cancelSubscription = () => {
    const data = { userId: userId };

    updateData('cancelSubscription', data)
      .then((response) => {
        setSubscriptionCancel(true);
        setShowModal(false);
        setActiveStep(2);
        setIsAlert(AlertType.Success);
        setAlertMsg(response.data.message);
      })
      .catch((error) => {
        setIsAlert(AlertType.Error);
        setAlertMsg(error.message);
      });
  };

  const confirmSubscription = () => {
    const data = { userId: userId };

    updateData('confirmSubscription', data)
      .then((response) => {
        setActiveStep(2);
        setIsAlert(AlertType.Success);
        setAlertMsg(response.data.message);
      })
      .catch((error) => {
        setIsAlert(AlertType.Error);
        setAlertMsg(error.data.message);
      });
  };

  const renderStep = (step: number) => {
    switch (step) {
      case 1:
        return (
          <ConfirmSubscriptionStep1
            onConfirmClick={() => confirmSubscription()}
            onCancelClick={() => setShowModal(true)}
            mainContent={litrals.yourAccountInactiveFor12Months}
            subContent={litrals.wouldLikeToContinue}
          />
        );

      case 2:
        return subscriptionCancel ? (
          <ConfirmSubscriptionStep2
            onButtonClick={() => window.location.reload()}
            mainContent={litrals.thanksForConfirmDontNeedSubscription}
            title={litrals.subscriptionCancelled}
            buttonName={litrals.done}
          />
        ) : (
          <ConfirmSubscriptionStep2
            onButtonClick={() => {
              window.location.reload();
            }}
            mainContent={litrals.thankyouForConfirming}
            subContent={litrals.youWillContinueToRecieveData}
            image={unionimg}
            title={litrals.subscriptionConfirmed}
            buttonName={litrals.continue}
            showInfo={litrals.ifYoyNeedToChangePersonalDetails}
          />
        );

      default:
        return (
          <ConfirmSubscriptionStep1
            onConfirmClick={() => setActiveStep(2)}
            onCancelClick={() => setShowModal(true)}
          />
        );
    }
  };

  return (
    <Col
      className="confirm-subscription-container"
      data-testid="confirm-subscription-conatainer"
    >
      <Container>
        <Row>
          <Col className="text-center">
            <img className="ntis-logo" src={logo} alt="ntis-logo" />
          </Col>
        </Row>
        {isAlert ? <Alert message={alertMsg} alert={isAlert} /> : ''}

        <Row className="content-container">
          <Col md={4} className="left-block">
            {confirmationSteps.map((item, index) => {
              return (
                <div className="steps text-center" key={'step' + index}>
                  <span
                    data-testid={`step-${item.step}`}
                    className={
                      activeStep === item.step
                        ? 'stepcount stepcount-active'
                        : activeStep > item.step
                        ? 'stepcount stepcount-filled'
                        : 'stepcount stepcount-inactive'
                    }
                  >
                    <p>{item.step}</p>
                  </span>
                  <p
                    className={
                      activeStep === item.step
                        ? 'heading heading-active'
                        : 'heading heading-inactive'
                    }
                  >
                    {item.stepHeading}
                  </p>
                </div>
              );
            })}
          </Col>
          <Col md={7} className="right-block">
            {renderStep(activeStep)}
          </Col>
        </Row>
      </Container>
      <ConfirmDataModal
        onConfirm={() => {
          cancelSubscription();
        }}
        onClose={() => setShowModal(false)}
        show={showModal}
        title={litrals.cancelSubscription}
        content={litrals.areYouSuretoCancelSubscription}
      />
    </Col>
  );
}

export default ConfirmSubscriptionContainer;
